module.exports = __webpack_public_path__ + "static/media/R-PANELv6.6-RC1/exportDataHover.c006304f.svg";